module.exports = __webpack_public_path__ + "img/img_communication_22.01f3c3e9.jpg";